import { acctServerInstance } from '../utilities/instances.js'
import { setUserPreference } from '../utilities/common.js'
import {
  USER_LOGIN_MOBILE,
  USER_LOGIN_MOBILE_SUCCESS,
  USER_LOGIN_MOBILE_FAIL,
  GET_ORDER_AND_SALARY,
  GET_ORDER_AND_SALARY_SUCCESS,
  GET_ORDER_AND_SALARY_FAIL,
  GET_ORDER_AND_SALARY_DETAIL,
  GET_ORDER_AND_SALARY_DETAIL_SUCCESS,
  GET_ORDER_AND_SALARY_DETAIL_FAIL,
  GET_ORDER_AND_SALARY_EMAIL,
  GET_ORDER_AND_SALARY_EMAIL_SUCCESS,
  GET_ORDER_AND_SALARY_EMAIL_FAIL,
  GET_ORDER_AND_SALARY_DETAIL_LA,
  GET_ORDER_AND_SALARY_DETAIL_LA_SUCCESS,
  GET_ORDER_AND_SALARY_DETAIL_LA_FAIL,
  GET_SALARY_ZIP_COUNT,
  GET_SALARY_ZIP_COUNT_SUCCESS,
  GET_SALARY_ZIP_COUNT_FAIL,
  GET_TEAM_ORDER_AND_SALARY,
  GET_TEAM_ORDER_AND_SALARY_SUCCESS,
  GET_TEAM_ORDER_AND_SALARY_FAIL,
  GET_TEAM_ORDER_AND_SALARY_DETAIL,
  GET_TEAM_ORDER_AND_SALARY_DETAIL_SUCCESS,
  GET_TEAM_ORDER_AND_SALARY_DETAIL_FAIL,
  GET_TEAM_ORDER_AND_SALARY_EMAIL,
  GET_TEAM_ORDER_AND_SALARY_EMAIL_SUCCESS,
  GET_TEAM_ORDER_AND_SALARY_EMAIL_FAIL,
  GET_TEAM_SALARY_ZIP_COUNT,
  GET_TEAM_SALARY_ZIP_COUNT_SUCCESS,
  GET_TEAM_SALARY_ZIP_COUNT_FAIL
} from './driverTypes.js'

export function logInUserMobile(username, password) {
  return function (dispatch) {
    dispatch({ type: USER_LOGIN_MOBILE })
    return acctServerInstance
      .post(`/login`, {
        username: username,
        password: password
      })
      .then(({ data }) => {
        dispatch({
          type: USER_LOGIN_MOBILE_SUCCESS,
          payload: data.data
        })
        setUserPreference(
          data.data.token,
          data.data.userinfo.level,
          data.data.userinfo.city_id,
          data.data.userinfo.username,
          data.data.userinfo.id,
          data.data.userinfo.subjectId
        )
        window.localStorage.setItem('driver_id', data.data.userinfo.id)
        window.localStorage.setItem('subject_id', data.data.userinfo.subjectId)
        acctServerInstance.defaults.headers.common['Authorization'] =
          `Bearer ${data.data.token}`
        return Promise.resolve(data.data)
      })
      .catch(error => {
        dispatch({
          type: USER_LOGIN_MOBILE_FAIL,
          payload: error
        })
        return Promise.reject(error)
      })
  }
}

/**
 *
 * @param {string} time1 i.e. 20240816
 * @param {string} time2
 * @returns {{
 *  data: Array<{
 *      amt: number
 *      amt_adj: number
 *      completed: number
 *      date: string i.e. "240816"
 *      incompleted: number
 *      owamt: number
 *      overweight: number
 *      paid: number
 *      unpaid: number
 *  }>
 *  driverinfo: Array<{
 *      id: string
 *      name: string
 *      email: string
 *      team_id: number
 *      team_leader: number
 *      show_salary: boolean
 *  }>
 *  userinfo: {
 *      id: string
 *      username: string
 *      level: number
 *      area: string
 *  }
 *  err_code: number
 *  ret_msg: string
 *  status: string
 * }}
 */
export function getOrdersAndSalary(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_ORDER_AND_SALARY })
    return acctServerInstance
      .get(`/ordersandsalary?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_SUCCESS,
          payload: data
        })
        return Promise.resolve(data)
      })
      .catch(error => {
        dispatch({
          type: GET_ORDER_AND_SALARY_FAIL,
          payload: error
        })
        return Promise.reject(error)
      })
  }
}

/**
 *
 * @param {string} time1
 * @param {string} time2
 * @returns {Array<{
 *      new: number
 *      completed: number
 *      date: string i.e. '24-08-16'
 * }>}
 */
export function getOrdersByDate(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_ORDER_AND_SALARY_DETAIL })
    return acctServerInstance
      .get(`/ordersbydate?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_DETAIL_SUCCESS,
          payload: data.data
        })
        return Promise.resolve(data.data)
      })
      .catch(error => {
        dispatch({
          type: GET_ORDER_AND_SALARY_DETAIL_FAIL,
          payload: error
        })
        return Promise.reject(error)
      })
  }
}

/**
 *
 * @param {string} email
 * @param {0|1} save
 * @param {string} time1
 * @param {string} time2
 * @returns
 */
export function getOrdersAndSalaryEmail(email, save, time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_ORDER_AND_SALARY_EMAIL })
    return acctServerInstance
      .get(
        `/ordersandsalaryemail?email=${email}&saveemail=${save}&time1=${time1}&time2=${time2}`
      )
      .then(({ data }) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_EMAIL_SUCCESS,
          payload: data
        })
        return Promise.resolve(data)
      })
      .catch(error => {
        dispatch({
          type: GET_ORDER_AND_SALARY_EMAIL_FAIL,
          payload: error
        })
        return Promise.reject(error)
      })
  }
}

/**
 *
 * @param {string} time1
 * @param {string} time2
 * @returns {Array<{
 *      zip: string
 *      count: number
 *      amount: number
 * }>}
 */
export function getOrdersByZip(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_SALARY_ZIP_COUNT })
    return acctServerInstance
      .get(`/ordersbyzip?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_SALARY_ZIP_COUNT_SUCCESS,
          payload: data.data
        })
        return Promise.resolve(data.data)
      })
      .catch(error => {
        dispatch({
          type: GET_SALARY_ZIP_COUNT_FAIL,
          payload: error
        })
        return Promise.reject(error)
      })
  }
}

/**
 *
 * @param {string} time1
 * @param {string} time2
 * @returns {Array<{
 *      new: number
 *      completed: number
 *      date: string
 * }>}
 */
export function getOrdersByDateLA(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_ORDER_AND_SALARY_DETAIL_LA })
    return acctServerInstance
      .get(`/getOrdersByDate_1?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_DETAIL_LA_SUCCESS,
          payload: data.data
        })
        return Promise.resolve(data.data)
      })
      .catch(error => {
        dispatch({
          type: GET_ORDER_AND_SALARY_DETAIL_LA_FAIL,
          payload: error
        })
        return Promise.reject(error)
      })
  }
}

/**
 *
 * @param {string} time1 i.e. 20240816
 * @param {string} time2
 * @returns {{
 *  data: Array<{
 *      amt: number
 *      amt_adj: number
 *      completed: number
 *      date: string i.e. "240816"
 *      incompleted: number
 *      owamt: number
 *      overweight: number
 *      paid: number
 *      unpaid: number
 *  }>
 *  driverinfo: Array<{
 *      id: string
 *      name: string
 *      email: string
 *      team_id: number
 *      team_leader: number
 *  }>
 *  userinfo: {
 *      id: string
 *      username: string
 *      level: number
 *      area: string
 *  }
 *  err_code: number
 *  ret_msg: string
 *  status: string
 * }}
 */
export function getTeamOrdersAndSalary(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_TEAM_ORDER_AND_SALARY })
    return acctServerInstance
      .get(`/teamordersandsalary?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_SUCCESS,
          payload: data
        })
        return Promise.resolve(data)
      })
      .catch(error => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_FAIL,
          payload: error
        })
        return Promise.reject(error)
      })
  }
}

/**
 *
 * @param {string} time1
 * @param {string} time2
 * @returns {Array<{
 *      new: number
 *      completed: number
 *      date: string
 * }>}
 */
export function getTeamOrdersByDate(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_TEAM_ORDER_AND_SALARY_DETAIL })
    return acctServerInstance
      .get(`/teamordersbydate?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_DETAIL_SUCCESS,
          payload: data.data
        })
        return Promise.resolve(data.data)
      })
      .catch(error => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_DETAIL_FAIL,
          payload: error
        })
        return Promise.reject(error)
      })
  }
}

/**
 *
 * @param {string} email
 * @param {0|1} save
 * @param {string} time1
 * @param {string} time2
 * @returns
 */
export function getTeamOrdersAndSalaryEmail(email, save, time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_TEAM_ORDER_AND_SALARY_EMAIL })
    return acctServerInstance
      .get(
        `/teamordersandsalaryemail?email=${email}&saveemail=${save}&time1=${time1}&time2=${time2}`
      )
      .then(({ data }) => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_EMAIL_SUCCESS,
          payload: data
        })
        return Promise.resolve(data)
      })
      .catch(error => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_EMAIL_FAIL,
          payload: error
        })
        return Promise.reject(error)
      })
  }
}

/**
 *
 * @param {string} time1
 * @param {string} time2
 * @returns {Array<{
 *      zip: string
 *      count: number
 *      amount: number
 * }>}
 */
export function getTeamOrdersByZip(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_TEAM_SALARY_ZIP_COUNT })
    return acctServerInstance
      .get(`/teamordersbyzip?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_TEAM_SALARY_ZIP_COUNT_SUCCESS,
          payload: data.data
        })
        return Promise.resolve(data.data)
      })
      .catch(error => {
        dispatch({
          type: GET_TEAM_SALARY_ZIP_COUNT_FAIL,
          payload: error
        })
        return Promise.reject(error)
      })
  }
}
